import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Paragraph from 'components/typography/Paragraph'
import Card from 'components/layout/Card'
import Header from 'components/typography/Header'
import Link from 'components/misc/Link'
import Button from 'components/forms/Button'
import Feature from './Feature'
import Dropdown from './Dropdown'
import styles from './styles/FeatureDropdown.css'
import commonStyles from './styles/DropdownCommon.css'

export const FeatureDropdown = () => {
  const history = useHistory()
  const [open, setOpen] = useState(false)

  return (
    <Dropdown open={open} setOpen={setOpen} title='Product'>
      <div className={styles.grid}>
        <div className={commonStyles.features}>
          <Feature
            to='/search'
            header='Search'
            img={`${CONFIG.assetsBaseURL}/images/icons/feature-search.svg`}
          >
            Discover supporting and contrasting evidence for papers
          </Feature>
          <Feature
            to='/?referenceCheck'
            header='Reference Check'
            img={`${CONFIG.assetsBaseURL}/images/icons/feature-page.svg`}
          >
            Upload a PDF to check if the references have been supported, contrasted, retracted, received an expression of concern, etc.
          </Feature>
          <Feature
            to='/create-dashboard'
            header='Custom Dashboards'
            img={`${CONFIG.assetsBaseURL}/images/icons/feature-dashboards.svg`}
          >
            Create custom dashboards to discover trends about groups of articles, search for claims made by them, or be notified of new citations to them
          </Feature>
          <Feature
            to='/journals'
            header='Journals'
            img={`${CONFIG.assetsBaseURL}/images/icons/feature-journals.svg`}
          >
            See journal-level Smart Citation metrics and discover which journals have published the most supported or contrasted articles
          </Feature>
          <Feature
            to='/affiliations'
            header='Organizations'
            img={`${CONFIG.assetsBaseURL}/images/icons/feature-journals.svg`}
          >
            See organization-level Smart Citation metrics and discover which organizations have published the most supported or contrasted articles
          </Feature>
          <Feature
            to='/institutions'
            header='Funders'
            img={`${CONFIG.assetsBaseURL}/images/icons/referrals.svg`}
          >
            Explore funding institutions dashboards to find their research, compare rankings, and see changes in their yearly scite Index
          </Feature>
        </div>
        <div className={styles.featured}>
          <Header className={commonStyles.header} level={6}>
            Updates
          </Header>
          <Card
            className={styles.card}
            onClick={() => {
              setOpen(false)
              history.push('/assistant')
            }}
          >
            <Button className={styles.button} color='blue'>New!</Button>
            <img alt='light bulb' className={styles.zoteroIllo} src={`${CONFIG.assetsBaseURL}/images/icons/partners-lightbulb.svg`} />
            <Header className={styles.updateHeader} level={3}>
              scite Assistant
            </Header>
            <Paragraph className={styles.updateParagraph}>
              Ask simple questions, get reliable answers straight from the full-text of research articles.
            </Paragraph>
          </Card>
        </div>
        <div className={styles.links}>
          <Link
            bold
            href='https://scite.ai/blog/introducing-the-scite-plug-in-for-zotero-61189d66120c'
            className={styles.link}
          > Zotero Plugin <i className={`icon icon-right-arrow ${styles.arrowImg}`} />
          </Link>
          <Link className={styles.link} bold to='/extension-install'>Download browser extension <i className={`icon icon-right-arrow ${styles.arrowImg}`} /></Link>
          <Link
            bold
            to={CONFIG.bookDemoURL}
            className={styles.link}
          > Schedule product demo <i className={`icon icon-right-arrow ${styles.arrowImg}`} />
          </Link>
          <Link
            bold href='https://help.scite.ai'
            className={styles.link}
          > Learn key concepts <i className={`icon icon-right-arrow ${styles.arrowImg}`} />
          </Link>
        </div>
      </div>
    </Dropdown>
  )
}

export default FeatureDropdown
